export const CHANNEL_JOB_LOGS_COLUMN = ['Date Time', 'Status', 'Request', 'Response', 'Error'];

export const CHANNEL_JOB_LOGS_TEST_ID = 'channel-job-logs';
export const CHANNEL_JOB_LOGS_TABLE_NAME = 'channel-job-logs';
